"use client";

import { useRef } from "react";

const BP = process.env.NEXT_PUBLIC_BASE_PATH ?? "";

export default function BannerVideo({
  videoPath,
  poster,
  style,
  startTime = 15,
}: {
  videoPath: string;
  poster?: string;
  style?: React.CSSProperties;
  startTime?: number;
}) {
  const ref = useRef<HTMLVideoElement>(null);

  const handleLoadedMetadata = () => {
    if (ref.current && startTime > 0) {
      ref.current.currentTime = Math.min(startTime, ref.current.duration - 1);
    }
  };

  return (
    <video
      ref={ref}
      autoPlay
      muted
      loop
      playsInline
      preload="auto"
      poster={poster}
      onLoadedMetadata={handleLoadedMetadata}
      style={style}
    >
      <source src={`${BP}/api/video/${videoPath}`} />
    </video>
  );
}
